// extracted by mini-css-extract-plugin
module.exports = {"container":"index-module_container_2a9vu","content":"index-module_content_3Kb-7","icon":"index-module_icon_33Zoa","title":"index-module_title_2mDiM"};